'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var coreRenderer = require('@tempi/core-renderer');
var ProductCard = require('../ProductCard/ProductCard.js');
var Slider = require('../../../../core/DsSlider/Slider.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    items = [],
    carouselOptions,
    layout
  } = _b, rest = __objRest(_b, [
    "items",
    "carouselOptions",
    "layout"
  ]);
  const { device } = coreRenderer.useStore();
  const slidesPerView = device === "mobile" ? 2.5 : carouselOptions.slidesPerView;
  return /* @__PURE__ */ jsxRuntime.jsx(Slider.DSSlider, __spreadProps(__spreadValues({}, carouselOptions), {
    slidesPerView,
    slidesPerViewMobile: 2.5,
    allowTouchMove: !(rest == null ? void 0 : rest.isEditingMode),
    children: items.map((product, index) => /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BreakpointWidthProvider, {
      sWidth: { value: 100 / 2.5, unit: "%" },
      mWidth: {
        value: 100 / carouselOptions.slidesPerView || 5,
        unit: "%"
      },
      children: /* @__PURE__ */ jsxRuntime.jsx(ProductCard.ProductCard, __spreadValues({
        product
      }, rest))
    }, index))
  }));
};

exports.ProductCarousel = ProductCarousel;
